// True for the array-likes that make up most of an emulator's state: the CPU's
// address space, the PPU's pattern memory, a mapper's bank registers.
//
// Plain objects are deliberately not covered. Some of them are shared tables
// (the APU's envelope and length counters, for one) that are cheaper to share
// than to copy and that nothing mutates in a way a caller can observe.
function isArrayLike(value) {
  return Array.isArray(value) || ArrayBuffer.isView(value);
}

module.exports = {
  copyArrayElements: function (src, srcPos, dest, destPos, length) {
    // A ROM bank (Uint8Array) into a typed memory (Uint8Array) is the hot case:
    // banking a CHR-ROM cart copies kilobytes on almost every register write.
    // `set` moves them in one call instead of one JS iteration per byte.
    if (
      length > 0 &&
      typeof src.subarray === "function" &&
      typeof dest.set === "function"
    ) {
      dest.set(src.subarray(srcPos, srcPos + length), destPos);
      return;
    }
    for (var i = 0; i < length; ++i) {
      dest[destPos + i] = src[srcPos + i];
    }
  },

  copyArray: function (src) {
    return src.slice(0);
  },

  // Copies on the way in as well as on the way out. A save state that shares a
  // buffer with the running machine is not a save state: it changes under the
  // caller as emulation continues, so restoring it later restores whatever the
  // machine happened to be doing by then. That is invisible once a state has been
  // through JSON.stringify, which is how the browser build saves, and shows up
  // immediately for anyone who keeps the object in memory.
  fromJSON: function (obj, state) {
    for (var i = 0; i < obj.JSON_PROPERTIES.length; i++) {
      var name = obj.JSON_PROPERTIES[i];
      var value = state[name];
      obj[name] = isArrayLike(value) ? value.slice(0) : value;
    }
  },

  toJSON: function (obj) {
    var state = {};
    for (var i = 0; i < obj.JSON_PROPERTIES.length; i++) {
      var name = obj.JSON_PROPERTIES[i];
      var value = obj[name];
      state[name] = isArrayLike(value) ? value.slice(0) : value;
    }
    return state;
  },
};
